import { useSetRecoilState } from 'recoil';

import { contractCheckoutAtom } from './atom';

export default function useSetContractCheckoutData() {
  return useSetRecoilState(contractCheckoutAtom);
}
